module.exports = "/_next/static/images/logo-light-b4c66bf59c393adc8d77e703bccdf53e.png";